module.exports = __webpack_public_path__ + "static/media/subway.df686a95.svg";